import { atom } from 'recoil';
import { blankUser } from '../interfaces/IUser';

const userAtom = atom({
  key: 'userState',
  default: blankUser
});

export default userAtom;
